import React, { Children } from 'react';

export const ProcessSwitch = ({ activeProcessIndex, onProcessIndexChange, processes }) => (
  <div className="process-switch mb-5">
    {Children.toArray(
      processes.map((e) => (
        <button
          type="button"
          onClick={() => onProcessIndexChange(e.index)}
          className={`process-switch-button ${e.index === activeProcessIndex ? 'active' : ''}`}
        >
          {e.title}
        </button>
      ))
    )}
  </div>
);
